import React, { Component } from 'react';

export default class ReassignReasonModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            reason: '',
        };
    }

    handleReasonChange = (e) => {
        this.setState({ reason: e.target.value });
    };

    handleSave = (e) => {
        e.stopPropagation();
        const reason = this.state.reason.trim();
        if (!reason) return;
        this.props.onSubmit(reason);
    };

    handleCancel = (e) => {
        e.stopPropagation();
        this.props.onCancel();
    };

    render() {
        const reason = this.state.reason.trim();

        return (
            <div
                className="admin-notes-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="admin-notes-modal-body">
                    <div className="admin-modal-content">
                        <h4>Reason for reassignment</h4>
                        <hr />
                        <p>This job is already assigned to another team member. Why is it being reassigned?</p>
                        <div className="form-group">
                            <textarea
                                className="form-control"
                                rows="3"
                                value={this.state.reason}
                                onChange={this.handleReasonChange}
                                placeholder="e.g. Original operative unavailable"
                                autoFocus
                                required
                            />
                        </div>
                        <div className="form-group">
                            <button className="btn btn-cw-primary" onClick={this.handleSave} disabled={!reason}>
                                Save
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div className="admin-notes-modal-footer">
                        <button className="btn btn-cw-primary" onClick={this.handleCancel}>
                            Cancel Reassignment
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
